const NO_PAYMENT_METHOD = 'none';
export function paymentMethodFingerprint(details) {
  var _details$type, _details$last;
  if (!details) return NO_PAYMENT_METHOD;
  return `${String((_details$type = details.type) !== null && _details$type !== void 0 ? _details$type : '')}:${(_details$last = details.last4) !== null && _details$last !== void 0 ? _details$last : ''}`;
}